import { MultipleItemResponse, fetchContent } from './fetchContent'
import { RolexProductPageV72024 } from './models/RolexProductPageV72024'

type Path = {
  locale: string
  params: {
    fid: string
    pid: string
  }
}

export const getCatchAllRolexProductPaths = async (preview?: boolean) => {
  let paths: Path[] = []
  const languages = ['nl', 'en', 'sg', 'de']
  for (const language of languages) {
    const lang = language === 'sg' ? 'en' : language
    const response: MultipleItemResponse<RolexProductPageV72024> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug', 'rolex_family'],
        'system.type[in]': ['rolex_product_page_v7_2024'],
        language: lang,
      },
    })

    response.items.forEach((item) => {
      if (item.system.language === lang && item.elements.url_slug.value.length) {
        paths.push({
          locale: lang,
          params: {
            fid: item.elements.rolex_family.value[0].name,
            pid: item.elements.url_slug.value,
          },
        })
      }
    })
  }

  return paths
}
